/**
 * 简单事件管理器
 * @description 对事件监听进行封装，隐藏事件绑定与触发细节
 * @author QC
 * @data 2020/08/26
 */
export default class EventManager{
  constructor() {
    this._eventMap = new Map()
  }

  hasEvent(evName) {
    return evName && this._eventMap.has(evName)
  }

  addEventListener(evName, cb) {
    if (!evName) {
      console.warn('Event name can not be null')
    } else {
      if (!this.hasEvent(evName)) {
        this._eventMap.set(evName, [])
      }
      this._eventMap.get(evName).push(cb)
    }
  }

  fireEvent(evName, data) {
    console.log('EventManager trigger event', evName)
    if (!evName) {
      console.warn('Event name can not be null')
    } else if(this.hasEvent(evName)) {
      this._eventMap.get(evName).forEach((cb) => {
        cb.call(this, data)
      })
    } else {
      console.warn('Can not find this event!', evName)
    }
  }
}